import { Space, SpaceTab } from 'api/space';

// spotlight, recents, project_files, general_shared_files or a folderId
export type UrlType = 'spotlight' | 'recents' | number;

export const SPOTLIGHT_FOLDER_ID = -1;
export const RECENTS_FOLDER_ID = -2;

export enum ListOrGridMode {
  List,
  Grid,
}

export interface CpSpacesData extends Record<string, unknown> {
  title: string;
  description: string;
  spotlightedSpaceTabs: SpaceTab[];
  spaces: Space[];
}

export interface CpSpaceProps {
  search: string;
  currentSpace: Space | undefined;
  onSpaceClick: (spaceId: UrlType | undefined) => void;
  data: CpSpacesData;
  mode: ListOrGridMode;
  setMode: (mode: ListOrGridMode) => void;
  currentSpaceTabs: SpaceTab[];
  onSpaceTabClick: (spaceTab: SpaceTab) => void;
}
